import utils from "core/utils";

type SelectOption = { label: string; value: string; category: string };

export type SupportedNewAddNodeOption = SelectOption & {
    iconData: Record<string, any>;
};

const SUPPORTED_NEW_ADD_NODE_OPTIONS: SupportedNewAddNodeOption[] = [
    {
        label: "Window",
        value: utils.ENTITIES.WINDOW,
        category: utils.ENTITIES.WINDOW,
        iconData: {
            label: "Window",
            type: utils.ENTITIES.WINDOW,
            componentType: utils.ENTITIES.WINDOW,
            metaObject: { type: utils.ENTITIES.WINDOW }
        }
    },
    {
        label: "Continuous Query",
        value: utils.ENTITIES.CQ,
        category: utils.ENTITIES.CQ,
        iconData: {
            label: "Continuous Query",
            type: utils.ENTITIES.CQ,
            componentType: utils.ENTITIES.CQ,
            metaObject: { type: utils.ENTITIES.CQ }
        }
    },
    {
        label: "Target",
        value: utils.ENTITIES.TARGET,
        category: utils.ENTITIES.TARGET,
        iconData: {
            label: "Target",
            type: utils.ENTITIES.TARGET,
            componentType: utils.ENTITIES.TARGET,
            metaObject: { type: utils.ENTITIES.TARGET }
        }
    },
    {
        label: "Router",
        value: utils.ENTITIES.ROUTER,
        category: utils.ENTITIES.ROUTER,
        iconData: {
            label: "Router",
            type: utils.ENTITIES.ROUTER,
            componentType: utils.ENTITIES.ROUTER,
            metaObject: { type: utils.ENTITIES.ROUTER }
        }
    },
    {
        label: "Waction Store",
        value: utils.ENTITIES.WACTIONSTORE,
        category: utils.ENTITIES.WACTIONSTORE,
        iconData: {
            label: "WActionStore",
            type: utils.ENTITIES.WACTIONSTORE,
            componentType: utils.ENTITIES.WACTIONSTORE,
            metaObject: { type: utils.ENTITIES.WACTIONSTORE }
        }
    }
];

const AI_NODES: SupportedNewAddNodeOption[] = [
    {
        label: "Sentinel",
        value: utils.ENTITIES.SENTINEL,
        category: utils.ENTITIES.SENTINEL,
        iconData: {
            label: "Sentinel",
            type: utils.ENTITIES.SENTINEL,
            componentType: utils.ENTITIES.SENTINEL,
            metaObject: { type: utils.ENTITIES.SENTINEL }
        }
    },
    {
        label: "Euclid",
        value: utils.ENTITIES.CQ,
        category: utils.ENTITIES.CQ,
        iconData: {
            label: "Euclid",
            type: utils.ENTITIES.CQ,
            componentType: utils.ENTITIES.CQ,
            metaObject: {
                type: utils.ENTITIES.CQ,
                uiconfig: { subType: "Euclid" }
            }
        }
    },
    {
        label: "Foreseer",
        value: utils.ENTITIES.CQ,
        category: utils.ENTITIES.CQ,
        iconData: {
            label: "Foreseer",
            type: utils.ENTITIES.CQ,
            componentType: utils.ENTITIES.CQ,
            metaObject: {
                type: utils.ENTITIES.CQ,
                uiconfig: { subType: "Foreseer" }
            }
        }
    }
];

export { SUPPORTED_NEW_ADD_NODE_OPTIONS, AI_NODES };
